// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__25Xlt","search":"Settings_search__1df7R","filter":"Settings_filter__rGnRj"};